import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import { Alert } from '../utils/Alert'
import EmployeeContext from '../utils/EmpDetails/EmployeeProvider'
import { companydetailnew, employeedetails, glUsrDataViaEmail, fetchGstTurnOverData, serviceVintage, apiAssignToCompany, fetcheEmployeeSearchDid } from '../services/merpservices'
import { glusr_details } from '../services/userservice'

// CSS
import '../assets/css/bootstrap-icons.css'
import '../assets/css/bootstrap.min.css'
import '../assets/css/fonts.css'
import '../assets/css/media-query.css'
import '../assets/css/style.css'
import { gaEvent } from '../utils/GoogleAnalytics/gatracking'
import { Glusr_identification_Creation } from '../services/loginIdentify'
import CustomerDetails from '../CustomerDetails/CustomerDetails'
import KnowledgeBase from '../components/KnowledgeBase/KnowledgeBase'
import VideoMeet from './VideoMeet'
import DisableReason from '../components/DisableReason/DisableReason'
import getCookie from '../utils/GetCookie/getCookie'
import getIP from '../utils/EmpDetails/getIP'
import IrateFlag from './IrateFlag';

const AppGloabalContext =  createContext();

export const useGlobalContext = () =>useContext(AppGloabalContext)

const SearchBar = ({handleLogout}) => {
  const employeeDetails = useContext(EmployeeContext);
  let empid = "";
  let ak = "";
  let ONum = "";
  let type = "";
  if (employeeDetails !== null) {
    empid = employeeDetails?.empid;
    ak = employeeDetails?.ak;
    ONum = employeeDetails?.ONum;
    type = employeeDetails?.type;
  }
  const [data, setData] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [glid, setGlid] = useState('')
  const [custtype_name, setCusttype_name] = useState('')
  const [companyData, setCompanyData] = useState([])
  const [dropDownValue, setDropDownValue] = useState('')
  const [hambuger, setHamburger] = useState(false);
  const [empDesginationDetials, setEmpDesginationDetials] = useState([]);
  const [source, setSource] = useState('');
  const [crtObjectId, setCrtObjectId] = useState('');
  const [dstPhone, setDstPhone] = useState('');
  const [ctcID, setCtcID] = useState('');
  const [turnover, setTurnover] = useState('');
  const [core_business_activity_nature, setCore_business_activity_nature] = useState('');
  const [vintage, setVintage] = useState('');
  const [showVideoMeetTooltip, setShowVideoMeetTooltip] = useState(false);
  const [phtype, setPhtype] = useState(0);
  const [custId, setCustId] = useState("");
  const [paidFree, setPaidFree] = useState("");
  const [verticalId, setVerticalId] = useState("");
  const [gluserDisableReasons, setGluserDisableReasons] = useState();
  const [parentGlid, setParentGlid] = useState();
  const [glusrData, setGlusrData] = useState({});
  const [displayIrateFlag, setDisplayIrateFlag] = useState(false);
  const [did, setDid] = useState(null);

  const wrapperRef = useRef(null);

  const url = new URL(document.location.href);
  const params = url.searchParams;
  const emailId = params.get('emailid');
  const phone = params.get('phone');
  const sourceParam = params.get('source');
  const crtObjectIdParam = params.get('crtObjectId');
  const dstPhoneParam = params.get('dstPhone');
  const ctcIDParam = params.get('ctcID');
  const searchkeyword = params.get('searchkeyword');
  const orginNumber = params.get('origNum')
  const autoSuggest = params.get('dropdown')
  let nglid = params.get('nglid')

  useEffect(() => {
    if (searchkeyword !== null) {
      setSearchTerm(searchkeyword);
    } else if (emailId) {
      setSearchTerm(emailId);
    } else if (phone) {
      setSearchTerm(phone);
    }
    if (sourceParam) {
      setSource(sourceParam);
    }
    if (crtObjectIdParam) {
      setCrtObjectId(crtObjectIdParam);
    }
    if (dstPhoneParam) {
      setDstPhone(dstPhoneParam);
    }
    if (ctcIDParam) {
      setCtcID(ctcIDParam);
    }

    if (searchTerm !== "") {
      companySearch(empid, ak, searchTerm);
    }
    if (autoSuggest === '1') {
      setIsVisible(false)
    }
  }, [empid]);


  useEffect(() => {
    if (searchTerm && (phone || emailId)) {
      companySearch(empid, ak, searchTerm);
    }
  }, [searchTerm])

  const selectDropdownValue = (value) => {
    setDropDownValue(value);
  }

  const searchFunctionalityGA = (ga) => {
    const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
    var searchType = '';
    if (dropDownValue !== "") {
      if (dropDownValue === "1") {
        searchType = 'Mobile Search';
      } else if (dropDownValue === "2") {
        searchType = 'Email Search';
      } else if (dropDownValue === "3") {
        searchType = 'Glid Search';
      } else if (dropDownValue === "4") {
        searchType = 'PNS Search';
      }
    } else {
      if (dropDownValue === "" && emailPattern.test(searchTerm)) {
        searchType = "Smart Email Search"
      } else if (ga === "GLID Search") {
        searchType = "Smart Glid Search"
      } else if (ga === "PNS Search") {
        searchType = "Smart PNS Search"
      } else if (ga === "Mobile Search") {
        searchType = 'Smart Mobile Search';
      }
    }
    gaEvent(searchType !== '' ? searchType : ga, searchType !== '' ? searchType : ga, 'Search', `empid: ${empid} | ucid: ${crtObjectIdParam}`, glid)

  }

  useEffect(() => {
    if (empid !== "") {
      companyDetails(empid, ak, nglid ?? phone, 1);
    }
  }, [empid])

  // console.log(companyData)

  const toggleVisibility = () => {
    setHamburger(!hambuger);
    setShowVideoMeetTooltip(false)
  };

  const companySearch = (empid, ak, value) => {
    setSearchTerm(value);
    if (value.length >= 3) {
      if (isNaN(value)) {
        var inputParam = '&email=' + value
        getData(empid, ak, inputParam);
        setCompanyData([])
      } else if (value.length >= 7 && value.length <= 15) {
        getData(empid, ak, '&mobile=' + value);
        if (data.length === 0) {
          companyDetails(empid, ak, value, "")
        }
        setCompanyData([])
      } else {
        companyDetails(empid, ak, value, "")
        setData([])
      }
    }
  };

  const glUserCreation = async (value) => {
    let number = searchTerm
    if (number.length === 12 && /^91/.test(number)) {
      number = number.slice(2)
    }
    const did = await fetchDidOfEmployee(empid, ak, phone);
    if (did === phone){
      setDid(did || null)
    }else{
      if (number.length === 10 && /^[6789]/.test(number)) {
        const ip = await getIP()
        const remoteIp = getCookie('CCIP') || ip.data?.ip;
        try {
          const res = await Glusr_identification_Creation(remoteIp, number)
          if (res.data.code === 200) {
            const data = res.data.DataCookie;
            if (value) {
              setGlid(data.glid)
            } else {
              changeURL(`&phone=${number}&nglid=${data.glid}`);
            }
          }
        } catch (error) {
          console.log("Error", error)
        }
      }
    }
  }

  const searchByInput = (inputValue) => {
    if (searchTerm === '') {
      Alert("Kindly Enter correct Mobile No/Email/PNS/GLID to search");
      return
    }
    if (data.length >= 1) {
      if (isNaN(inputValue)) {
        changeURL(`&emailid=${inputValue}&nglid=${data[0]?.GLUSR_USR_ID}`)
        searchFunctionalityGA("Email Search")
      } else {
        changeURL(`&phone=${inputValue}&nglid=${data[0]?.GLUSR_USR_ID}`);
        searchFunctionalityGA("Mobile Search");
      }
    } else if (companyData.length >= 1) {
      const glid = companyData[0]?.GLUSR_USR_ID;
      if (searchTerm === glid) {
        searchFunctionalityGA("GLID Search");
      } else {
        searchFunctionalityGA("PNS Search");
      }
      glusrDetails(ak, glid, inputValue);
    } else if (data.length === 0 && companyData.length === 0) {
      // changeURL(`&phone=${inputValue}`);
      glUserCreation()
      searchFunctionalityGA("Mobile Search");
    }
  }
  

  const fetchDidOfEmployee = async (empid, ak, keyword) => {
    try {
      if(data.length === 0 && companyData.length === 0){
        const res = await fetcheEmployeeSearchDid(empid, ak, keyword);
        if (res?.data?.status === 200) {
          const did = res?.data?.data?.queryData?.[0]?.CAMPAIGN_DID;
          setDid(did?.replace(/^\+91/, '') || null);
          return did?.replace(/^\+91/, '') || null;
        }
      }
      return null;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  };


  const getData = async (empid, ak, inputParam) => {
    try {
      const res = await glUsrDataViaEmail(empid, ak, inputParam);
      if (res?.data?.status_code === 200) {
        // const result = res?.data?.data;
        let responseData = res?.data
        if (responseData?.data?.length >= 1) {
          setPhtype(1);
        };
        // Sorting glids based on custtype weight
        responseData.data.sort((a, b) => {
          const weightA = parseInt(a.GLUSR_USR_CUSTTYPE_WEIGHT) || 0;
          const weightB = parseInt(b.GLUSR_USR_CUSTTYPE_WEIGHT) || 0;

          return weightA - weightB;
        });
        setData(responseData.data);
        if (phone) {
          setGlid(responseData?.data[0]?.GLUSR_USR_ID)
          custyTypeID(responseData?.data[0]?.GLUSR_USR_ID); // Calling when we get glid from glUsrdetails API on the intial render
        }
      } else if (res?.data?.status_code === 204) {
        companyDetails(empid, ak, inputParam.split('=')[1], "");
        setData([])
      }
    } catch (error) {
      console.log("Error", error)
    }
  }

  const companyDetails = async (empid, ak, keyword, custtype = "") => {
    if (keyword) {
      try {
        const res = await companydetailnew(empid, ak, keyword);
        if (res?.data[0].status === "200") {
          const result = res?.data[0]?.data;
          if (result.length) {
            setPhtype(1);
            setCompanyData(result)
            if (phone) {
              setGlid(result[0]?.GLUSR_USR_ID)
              custyTypeID(result[0]?.GLUSR_USR_ID); // Calling when we get glid from company details API on the intial render, it gives Fee and Premium on top bar
            }
            if (custtype === 1) {
              setCusttype_name(result[0]?.CUSTTYPE_NAME ?? '');
            }
          } else {
            glUserCreation(1);
          }
        }
      } catch (error) {
        console.log("Error", error)
      }
    }
  }

  const glusrDetails = async (ak, glid, searchkeyword) => {
    try {
      const res = await glusr_details(ak, glid);
      const glusrPhNo = res?.data?.glusr_usr_ph_mobile;
      const email = res?.data?.glusr_usr_email;
      if (glusrPhNo === null) {
        if (email !== null) {
          changeURL(`&phone=&searchkeyword=${searchkeyword}&emailid=${email}&nglid=${glid}`);
        } else {
          changeURL(`&phone=&searchkeyword=${searchkeyword}&nglid=${glid}`);
        }
      } else {
        changeURL(`&phone=${glusrPhNo}&searchkeyword=${searchkeyword}&nglid=${glid}`);
      }
    } catch (error) {
      console.log("Error", error)
    }
  }


  const changeURL = (param) => {
    const url = `?source=${source}&empid=${empid}&action=search&crtObjectId=${crtObjectId}&dstPhone=${dstPhone}&rsrch=1${param.replace(/\s/g, '')}&origNum=${ONum}&ctcID=${ctcID}&dropdown=1${type ? `&type=${type}` : ''}`;
    window.location.href = url;
  }


  useEffect(() => {
    // Function to handle clicks outside of the div
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const getGlid = async (glid, custtype_name, index) => {
    setCusttype_name(custtype_name ?? "")
    setGlid(glid);
    //GA tracking based on auto suggested
    if (data.length >= 1) {
      searchFunctionalityGA(isNaN(searchTerm) ? "Smart Email Search" : "Smart Mobile Search");
    } else if (companyData.length >= 1) {
      searchFunctionalityGA(searchTerm === companyData[0]?.GLUSR_USR_ID ? "Smart GLID Search" : "Smart PNS Search");
    } else {
      searchFunctionalityGA("Smart Mobile Search");
    }
    
    try {
      const res = await glusr_details(ak, glid);
      const glusrPhNo = res?.data?.glusr_usr_ph_mobile;
      const email = res?.data?.glusr_usr_email;
      if (glusrPhNo !== '' || glusrPhNo !== null) {
        if (data.length > 1) {
          if (glusrPhNo === null) {
            if (email !== null) {
              changeURL(`&emailid=${email}&searchkeyword=${searchTerm}&nglid=${glid}`); // passing nglid param in browser URL for getting disable icon
            }
          } else {
            changeURL(`&phone=${glusrPhNo}&nglid=${glid}&searchkeyword=${searchTerm}`);
          }
        } else {
          if (glusrPhNo === null) {
            if (email !== null) {
              changeURL(`&emailid=${email}&searchkeyword=${searchTerm}&nglid=${glid}`); // passing nglid param in browser URL for getting disable icon
            } else {
              changeURL(`&phone=&searchkeyword=${searchTerm}`);
            }
          } else {
            changeURL(`&phone=${glusrPhNo}&searchkeyword=${searchTerm}&nglid=${glid}`);
          }
        }
      }
    } catch (error) {

    }
  }

  const leftHamburger = (val) => {
    if (val === 'report') {
      window.open(`/api/data_dump`, '_blank');
    } else if (val === 'admin') {
      window.open('https://vendors.intermesh.net/Models/addRemoveCliDispositions.php')
    } else if (val === 'logout') {
      handleLogout();
      // window.location.href = 'https://vendors.intermesh.net/Controllers/inBoundCenter.php?logout=1'
    }
  }

  const empDetails = async (empid, ak) => {
    try {
      const response = await employeedetails(empid, ak);
      if (response?.data?.status === "200") {
        const dataHash = response?.data?.data;
        setEmpDesginationDetials(dataHash?.employeeDetails)
      }
    } catch (error) {
      console.log("Error", error)
    }
  }

  const gstTurnover = async (empid, ak, glid) => {
    if (ak !== "") {
      try {
        const response = await fetchGstTurnOverData(empid, ak, glid)
        if (response?.data?.status === 200) {
          if (response?.data?.Data.code === 200) {
            const gst_turnover = response?.data?.Data?.data?.values[0].shortname_turnover;
            setTurnover(gst_turnover === 'NA' ? "" : `|  ₹ ${gst_turnover}`)
            setCore_business_activity_nature(response?.data?.Data?.data?.values[0].core_business_activity_nature)
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  const service_vintage = async (empid, ak, glid) => {
    if (ak !== '') {
      try {
        const response = await serviceVintage(empid, ak, glid);
        if (response?.data?.status === 200) {
          const data = response?.data?.data[0].SERVICE_VINTAGE;
          if (data) {
            const serviceVintage = data.split(" ");
            if (serviceVintage[0] !== "0") {
              setVintage(`| ${serviceVintage[0]} Y`);
            } else if (serviceVintage[2] !== "0") {
              setVintage(`| ${serviceVintage[2]} M`);
            } else {
              setVintage(`| ${serviceVintage[5]} D`);
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  useEffect(() => {
    if (ak !== '') {
      empDetails(empid, ak)
    }
  }, [empid, ak])

  useEffect(() => {
    if (nglid !== '' && nglid !== null) {
      gstTurnover(empid, ak, nglid)
      service_vintage(empid, ak, nglid)
    }
  }, [ak])


  const allowed_emp_ids = ["50060", "29545", "37647", "93805", "85789", "93639", "100659", "64374", "94090", "107140", "113875"]

  const paidCustArray = [1, 2, 7, 10, 12, 13, 15, 31, 48];

  const custyTypeID = async (glid) => {
    let res = await apiAssignToCompany(nglid ?? glid, 1);
    if (res?.data?.status === 200) {
      const custID = res?.data?.GLUSR_USR_CUSTTYPE_ID === "" ? 0 : res?.data?.GLUSR_USR_CUSTTYPE_ID;
      setCustId(parseInt(custID))
      if (paidCustArray.includes(parseInt(custID))) {
        setPaidFree("Paid | ")
      } else {
        setPaidFree("Free | ")
      }
    }
  }

  return (
    <AppGloabalContext.Provider value={{ paidFree, setGluserDisableReasons, custId,  parentGlid , setParentGlid, glid, glusrData, setGlusrData, displayIrateFlag, setDisplayIrateFlag, verticalId, setVerticalId, did}}>
    <>
      <header className='h-42'>
        <div className="container-fluid">
          <div className="main-bar">
            <div className="d-flex justify-content-between align-items-center">
              <div className="left-sec">
                <div className="input-box h-38">
                  <div className="input-group">
                    <input
                      type="text"
                      id="searchno_email"
                      className="form-control h-38"
                      placeholder="Mobile, Email, GLID or PNS"
                      aria-label="Dollar amount (with dot and two decimal places"
                      value={searchTerm}
                      onKeyDown={(e) => {
                        if (e.key === "Enter")
                          searchByInput(searchTerm);
                      }}
                      onPaste={(e) => {
                        companySearch(empid, ak, e.target.value);
                      }}
                      onChange={(e) => {
                        companySearch(empid, ak, e.target.value);
                      }}
                      onClick={(e) => {
                        setHamburger(false);
                        setShowVideoMeetTooltip(false)
                        setIsVisible(true);
                      }}
                    />
                    <div className="search-result">
                      {searchTerm === "" ? (
                        ""
                      ) : data.length === 0 ? (
                        <>
                          {companyData.length === 0 ? (
                            <></>
                          ) : (
                            <div
                              className="resultbox fs-outfit"
                              style={{ display: isVisible ? "block" : "none" }}
                              ref={wrapperRef}
                            >
                              {companyData.slice(0, 3).map((data, i) => {
                                const {
                                  GLUSR_USR_COMPANYNAME,
                                  GLUSR_USR_ID,
                                  CUSTTYPE_NAME,
                                } = data;
                                return (
                                  <div
                                    key={`${GLUSR_USR_ID}{i}`}
                                    className="companylist cp fw600 fs-outfit"
                                    onClick={() => {
                                      getGlid(GLUSR_USR_ID, CUSTTYPE_NAME, i);
                                    }}
                                  >
                                    <span
                                      id="glusr_company"
                                      className="colorgreen fw500 fs-outfit"
                                    >
                                      {GLUSR_USR_COMPANYNAME} [{GLUSR_USR_ID}]
                                    </span>{" "}
                                    <br />
                                    <span id="cust_type" className="fw400">
                                      {CUSTTYPE_NAME}
                                    </span>{" "}
                                    <br />
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          className="resultbox fs-outfit"
                          style={{ display: isVisible ? "block" : "none" }}
                          ref={wrapperRef}
                        >
                          {data.slice(0, 4).map((data, i) => {
                            const {
                              GLUSR_USR_COMPANYNAME,
                              GLUSR_USR_FIRSTNAME,
                              GLUSR_USR_LASTNAME,
                              GLUSR_USR_ID,
                              GLUSR_USR_CUSTTYPE_NAME,
                              FK_PARENT_GLUSR_ID,
                            } = data;
                            const fname = GLUSR_USR_FIRSTNAME ?? "";
                            const lname = GLUSR_USR_LASTNAME ?? "";
                            return (
                              <div
                                key={GLUSR_USR_ID}
                                className={
                                  nglid === null
                                    ? "companylist fs-outfit"
                                    : nglid === GLUSR_USR_ID
                                      ? "companylist fs-outfit"
                                      : "companylist1"
                                }
                                onClick={() => {
                                  getGlid(
                                    GLUSR_USR_ID,
                                    GLUSR_USR_CUSTTYPE_NAME,
                                    i
                                  );
                                }}
                              >
                                <span
                                  className={
                                    nglid === null
                                      ? "colorgreen"
                                      : nglid === GLUSR_USR_ID
                                        ? "colorgreen fw500"
                                        : ""
                                  }
                                >
                                  {GLUSR_USR_COMPANYNAME} [{GLUSR_USR_ID}]
                                </span>
                                <br />
                                <span className="fw400">
                                  {fname + " " + lname}
                                </span>
                                <br />
                                <span className="fw400">
                                  {GLUSR_USR_CUSTTYPE_NAME}
                                  {FK_PARENT_GLUSR_ID !== null ? (
                                    <>
                                      {" "}
                                      <br />{" "}
                                      <span
                                        className={
                                          nglid === GLUSR_USR_ID
                                            ? "colorgreen fw500"
                                            : ""
                                        }
                                      >
                                        Parent({FK_PARENT_GLUSR_ID})
                                      </span>{" "}
                                    </>
                                  ) : (
                                    " "
                                  )}
                                </span>{" "}
                                <br />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <span
                      className="input-group-text"
                      onClick={() => {
                        searchByInput(searchTerm);
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="right-sec">
                <ul>
                  <IrateFlag />
                  <li>
                    <a>
                      {gluserDisableReasons && <DisableReason disableDetails={gluserDisableReasons}/>}
                      {(phone || emailId) && `${paidFree}`}

                      {nglid ?? glid}
                      {(phone || emailId) && custtype_name && (
                        <> | <span className="custtype">{custtype_name} {turnover} {vintage}
                          <VideoMeet glid={glid} ak={ak}/>
                        </span></>
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                    >
                      <i className="bi bi-list" onClick={() => {
                        toggleVisibility();
                      }}></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {empDesginationDetials.length !== 0 ? (
          <>
            {empDesginationDetials.map((emp_value) => {
              const { DESIGNATIONNAME } = emp_value;
              return (
                <>
                  {allowed_emp_ids.includes(empid) ? (
                    <div
                      key={emp_value}
                      style={{ display: hambuger ? "block" : "none" }}
                    >
                      <div className="Frame1000009573 cp">
                        <div
                          className="reportbtn"
                          onClick={() => {
                            leftHamburger("report");
                          }}
                        >
                          Report
                          <div className="line85"></div>
                        </div>
                        <div
                          className="adminbtn"
                          onClick={() => {
                            leftHamburger("admin");
                          }}
                        >
                          Admin
                          <div className="line85"></div>
                        </div>
                        <div
                          className="logout-btn"
                          onClick={() => {
                            leftHamburger("logout");
                          }}
                        >
                          Logout
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ display: hambuger ? "block" : "none" }}>
                        <div className="Frame1000009573 cp">
                          {
                            (DESIGNATIONNAME !== "Executive" || empid === "117113" || empid === "113881" || empid === "113870") ? <div
                              className="reportbtn"
                              onClick={() => {
                                leftHamburger("report");
                              }}
                            >
                              Report
                              <div className="line85"></div>
                            </div> : <></>
                          }
                          <div
                            className="logout-btn"
                            onClick={() => {
                              leftHamburger("logout");
                            }}
                          >
                            Logout
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              );
            })}
          </>
        ) : (
          <></>
        )}
      </header>
      {
        empid !== "" && ak !== "" ? (
          <>
            <CustomerDetails empid={empid} ak={ak} glid={nglid ?? glid} businessNature={core_business_activity_nature} phtype={phtype} />
          </>
        ) : (
          ""
        )
      }
      <KnowledgeBase />
    </>
    </AppGloabalContext.Provider>
  );
}

export default SearchBar